const olElem = document.querySelectorAll('.wdgt-OfferLinks');
window.fireOnVisible(olElem, async () => {
    await import('./assets/css/offerlinks.scss').then(async () => {
        await import('../../assets/frontend/styles/ck24_tcms_expandList.scss');
    });
});
